export const NODE_ENVIROMENT_VAR = Object.freeze({
  pro: 'production',
  dev: 'development',
});
